/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const zhHKRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: '請求增加學校',
    description: '請填寫下面的表格。我們不能保證增加被提交的學校，但 SheerID 將研究和考慮所有請求。 ',
    noCountry: '看不到您學校所在的國家？您不符合獲得此優惠的資格',
    searchByOrgName: '找不到您的學校？依名稱搜尋',
    completeRequest: '在符合條件或不符合條件的學校列表中看不到您的學校？完成您的請求',
    submit: '提交',
    eligibleOrgs: '符合條件的學校。點按圖示以複製名稱，然後返回驗證表格',
    ineligibleOrgs: '不符合條件的學校。很抱歉，這些學校的學生不符合這個優惠的資格',
    none: '沒有',
    country: '你在哪裡上學？',
    changeLanguage: '更改語言',
    copied: '複製',
    firstName: '名字',
    lastName: '姓',
    emailAddress: '电子邮件地址',
    poweredBy: '由 SheerID 提供的驗證服務',
    fields: {
        countryPlaceholder: '選擇國家',
        domainLabel: '學校網站',
        domainPlaceholder: 'www.我的學校.教育',
        orgNameLabel: '學校名稱',
        orgNamePlaceholder: '我的學校',
    },
    step: {
        success: {
            title: '感謝您提交您的學校請求',
            description: '請注意，每個請求都會根據此優惠設定的需求依 SheerID 評估。無法保證會加入您的學校。評估程序將需要長達 7 天時間。',
        },
        error: {
            title: '發生意外錯誤',
            description: '抱歉，我們無法處理您的請求。請稍候再試。',
            seeingProblem: '如果您還遇到這個問題',
            contactUs: '聯絡我們',
        },
    },
    errorId: {
        invalidCountry: '必填項目',
        invalidEmail: '電子郵件無效',
        invalidFirstName: '名字無效',
        invalidLastName: '姓氏無效',
        requiredField: '必填項目',
        invalidField: '項目無效',
        invalidUrl: '鏈結無效',
        tooManyResults: '您的搜尋得到太多結果，請縮小搜尋範圍，然後重試',
    },
    faq: 'SheerID 增加學校請求的常見問題',
    countries: {
        AD: ' 安道爾',
        AE: '阿聯酋',
        AF: '阿富汗',
        AG: '安堤瓜及巴爾布達',
        AI: '安圭拉',
        AL: '阿爾巴尼亞',
        AM: '亞美尼亞',
        AN: '荷屬安的列斯群島',
        AO: '安哥拉',
        AR: '阿根廷',
        AS: '美屬薩摩亞',
        AT: '奧地利',
        AU: '澳大利亞',
        AW: '阿魯巴',
        AZ: '阿塞拜疆',
        BA: '波黑',
        BB: '巴巴多斯',
        BD: '孟加拉',
        BE: '比利時',
        BF: '伯基納法索',
        BG: '保加利亞',
        BH: '巴林',
        BI: '布隆迪',
        BJ: '貝南',
        BM: '百慕大',
        BN: '汶萊',
        BO: '玻利維亞',
        BR: '巴西',
        BS: '巴哈馬',
        BT: '不丹',
        BV: '布維島',
        BW: '波劄那',
        BY: '白俄羅斯',
        BZ: '貝裡斯',
        CA: '加拿大',
        CD: '剛果民主共和國',
        CF: '中非共和國',
        CG: '剛果',
        CH: '瑞士',
        CI: '象牙海岸（科特迪瓦）',
        CK: '科克群島',
        CL: '智利',
        CM: '喀麥隆',
        CN: '中國',
        CO: '哥倫比亞',
        CR: '哥斯大黎加',
        CU: '古巴',
        CV: '佛得角',
        CY: '賽普勒斯',
        CZ: '捷克共和國',
        DE: '德國',
        DJ: '吉佈提',
        DK: '丹麥',
        DM: '多明尼克',
        DO: '多明尼克共和國',
        DZ: '阿爾及利亞',
        EC: '厄瓜多',
        EE: '愛沙尼亞',
        EG: '埃及',
        EH: '西撒哈拉',
        ER: '厄利垂亞',
        ES: '西班牙',
        ET: '衣索比亞',
        FI: '芬蘭',
        FJ: '斐濟',
        FK: '福克蘭群島',
        FM: '密克羅尼西亞',
        FO: '法羅群島',
        FR: '法國',
        GA: '加蓬',
        GB: '英國',
        GD: '格林納達',
        GE: '格魯吉亞',
        GF: '法屬圭亞那',
        GH: '加納',
        GI: '直布羅陀',
        GL: '格陵蘭島',
        GM: '岡比亞',
        GN: '幾內亞',
        GP: '瓜德羅普（法語）',
        GQ: '赤道幾內亞',
        GR: '希臘',
        GS: '南喬治亞島和南桑威奇群島',
        GT: '瓜地馬拉',
        GU: '關島（美國）',
        GW: '幾內亞·比索',
        GY: '蓋亞那',
        HK: '香港',
        HM: '赫德島和麥克唐納群島',
        HN: '洪都拉斯',
        HR: '克羅地亞',
        HT: '海地',
        HU: '匈牙利',
        ID: '印度尼西亞',
        IE: '愛爾蘭',
        IL: '以色列',
        IN: '印度',
        IO: '英屬印度洋領地',
        IQ: '伊拉克',
        IR: '伊朗',
        IS: '冰島',
        IT: '義大利',
        JM: '牙買加',
        JO: '約旦',
        JP: '日本',
        KE: '肯雅',
        KG: '吉爾吉斯斯坦',
        KH: '高棉',
        KI: '吉裡巴斯',
        KM: '科摩羅',
        KN: '聖基茨和尼維斯安圭拉',
        KP: '朝鮮',
        KR: '韓國',
        KW: '科威特',
        KY: '英屬開曼群島',
        KZ: '哈薩克',
        LA: '老撾',
        LB: '黎巴嫩',
        LC: '聖盧西亞',
        LI: '列支敦士登',
        LK: '斯里蘭卡',
        LR: '賴比瑞亞',
        LS: '萊索托',
        LT: '立陶宛',
        LU: '盧森堡',
        LV: '拉脫維亞',
        LY: '利比亞',
        MA: '摩洛哥',
        MC: '摩納哥',
        MD: '摩爾達維亞',
        ME: '黑山',
        MG: '馬拉加西',
        MH: '馬紹爾群島',
        MK: '馬其頓',
        ML: '馬利',
        MM: '緬甸',
        MN: '蒙古',
        MO: '澳門',
        MP: '北馬利安納群島',
        MQ: '馬提尼克（法語）',
        MR: '茅利塔尼亞',
        MS: '蒙特塞拉特島',
        MT: '馬爾他',
        MU: '模裡西斯',
        MV: '瑪律地夫',
        MW: '馬拉威',
        MX: '墨西哥',
        MY: '馬來西亞',
        MZ: '莫三比克',
        NA: '納米比亞',
        NC: '新赫里多尼亞（法語）',
        NE: '尼日',
        NF: '諾福克島',
        NG: '奈及利亞',
        NI: '尼加拉瓜',
        NL: '荷蘭',
        NO: '挪威',
        NP: '尼泊爾',
        NR: '瑙魯',
        NU: '紐埃',
        NZ: '紐西蘭',
        OM: '阿曼',
        PA: '巴拿馬',
        PE: '秘魯',
        PF: '波利尼西亞（法語）',
        PG: '巴布亞新磯內亞',
        PH: '菲律賓',
        PK: '巴基斯坦',
        PL: '波蘭',
        PM: '聖皮爾和密克隆',
        PN: '皮特克恩島',
        PR: '波多黎各',
        PS: '巴勒斯坦',
        PT: '葡萄牙',
        PW: '帕勞',
        PY: '巴拉圭',
        QA: '卡塔爾',
        RE: '留尼汪（法語）',
        RO: '羅馬尼亞',
        RS: '塞爾維亞',
        RU: '俄羅斯聯邦',
        RW: '盧安達',
        SA: '沙烏地阿拉伯',
        SB: '所羅門群島',
        SC: '塞舌耳',
        SD: '蘇丹',
        SE: '瑞典',
        SG: '新加坡',
        SH: '聖赫倫那島',
        SI: '斯洛文尼亞',
        SK: '斯洛伐克共和國',
        SL: '塞拉里昂',
        SM: '聖馬利諾',
        SN: '塞內加爾',
        SO: '索馬利亞',
        SR: '蘇利南',
        SS: '南蘇丹',
        ST: '聖多美及普林西比',
        SV: '薩爾瓦多',
        SY: '敘利亞',
        SZ: '史瓦濟蘭',
        TC: '特克斯和凱科斯群島',
        TD: '查德',
        TF: '法屬南部領地',
        TG: '多哥',
        TH: '泰國',
        TJ: '塔吉克',
        TK: '托克勞群島',
        TL: '東帝汶',
        TM: '土庫曼',
        TN: '突尼斯',
        TO: '東加',
        TR: '土耳其',
        TT: '千裡達托貝哥',
        TV: '吐瓦魯',
        TW: '臺灣',
        TZ: '坦尚尼亞',
        UA: '烏克蘭',
        UG: '烏干達',
        UM: '美國本土外小島嶼',
        US: '美國',
        UY: '烏拉圭',
        UZ: '烏茲別克',
        VA: '梵蒂岡',
        VC: '聖文森特和格林納丁斯',
        VE: '委內瑞拉',
        VG: '維京群島（英國）',
        VI: '維京群島（美國）',
        VN: '越南',
        VU: '瓦努阿圖',
        WF: '瓦利斯和富圖納群島',
        WS: '薩摩亞',
        XK: '科索沃',
        YE: '葉門',
        YT: '馬約特',
        ZA: '南非',
        ZM: '尚比亞',
        ZW: '辛巴威',
    },
    locales: {
        ar: ' 阿拉伯語',
        bg: '保加利亞語',
        cs: '捷克語',
        da: '丹麥語',
        de: '德語',
        el: '希臘語',
        'en-GB': '英語（英國）',
        'en-US': '英語',
        'es-ES': '西班牙語（西班牙）',
        es: '西班牙語',
        fi: '芬蘭語',
        'fr-CA': '法语（加拿大）',
        fr: '法語',
        hr: '克羅地亞語',
        hu: '匈牙利語',
        id: '印尼語',
        is: '冰島語',
        it: '義大利語',
        iw: '希伯來語',
        ja: '日語',
        ko: '韓語',
        lt: '立陶宛語',
        ms: '馬來語',
        nl: '荷蘭語',
        no: '挪威語',
        pl: '波蘭語',
        'pt-BR': '葡萄牙語（巴西）',
        pt: '葡萄牙語',
        ro: '羅馬尼亞語',
        ru: '俄羅斯',
        sk: '斯洛伐克語',
        sl: '斯洛文尼亞語',
        sr: '塞爾維亞語',
        sv: '瑞典語',
        tr: '土耳其語',
        'zh-HK': '中文（香港）',
        zh: '中文（繁體）',
    },
};
